
export class Room {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.name = params.name ? params.name : null
  }
}
